import React from 'react';
import { Box, Typography } from '@mui/material';
import './Statistics.css';

/**
 * Statistics Component
 * Displays combined statistics for all cameras
 */
const Statistics = ({ statistics }) => {
    const stats = [
        {
            label: 'Ukupno',
            value: statistics?.total_events || 0,
        },
        {
            label: 'ANPR',
            value: statistics?.anpr_events || 0,
        },
        {
            label: 'Heartbeat',
            value: statistics?.heartbeat_events || 0,
        },
        {
            label: 'Tablice',
            value: statistics?.unique_plates || 0,
        }
    ];

    return (
        <Box className="statistics-container">
            {stats.map((stat, index) => (
                <Box
                    key={index}
                    sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px 30px', borderRadius: '12px', color: 'black', minWidth: '120px', flex: 1, boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)', backgroundColor: '#1976d2', color: 'white' }}
                >
                    <Typography sx={{ fontSize: '32px', fontWeight: 'bold', marginBottom: '5px' }}>{stat.value}</Typography>
                    <Typography >{stat.label}</Typography>
                </Box>
            ))}
        </Box>
    );
};

export default Statistics;
